import { showAlert, hideAlert } from '../Dashboard/actions';
import { useAction } from '../Common/hooks';

const useAlert = () => {
  const dispatchShowAlert = useAction(showAlert);
  const dispatchHideAlert = useAction(hideAlert);

  return {
    showAlert: dispatchShowAlert,
    hideAlert: dispatchHideAlert,
  };
};

export default useAlert;
